<template>
  <div class='mainContainer'>
    <div class='nav'>
      <div class='navContainer' style='width: 240px'>
        <p>供应商名称：</p>
        <el-input v-model='condition.supplierName' size='mini' style='width:150px'
                  placeholder='请输入供应商名称' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>车牌号：</p>
        <el-input v-model='condition.truckName' size='mini' style='width:150px'
                  placeholder='请输入车牌号' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>司机姓名：</p>
        <el-input v-model='condition.driverName' size='mini' style='width:150px'
                  placeholder='请输入司机姓名' />
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>换板状态：</p>
        <el-select v-model='condition.isBoard' filterable size='mini' style='width:150px'
                   placeholder='请选择换板状态'>
          <el-option v-for='item in isBoardOption' :key='item.val' :label='item.name'
                     :value='item.val' />
        </el-select>
      </div>
      <div class='navContainer' style='width: 240px'>
        <p>状态：</p>
        <el-select v-model='condition.status' filterable size='mini' style='width:150px'
                   placeholder='请选择状态'>
          <el-option v-for='item in statusOption' :key='item.val' :label='item.name'
                     :value='item.val' />
        </el-select>
      </div>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
      </div>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          row-key='id'
          :data='TableDatas'
          style='width: 100%'
          border stripe
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px'}"
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
        >
          <el-table-column label='序号' align='center' width='50px' type='index' />
          <el-table-column prop='supplierName' label='供应商名称' width='150' show-overflow-tooltip
                           align='center' />
          <el-table-column prop='truckName' label='车牌号' min-width='100' align='center' />
          <el-table-column prop='driverName' label='司机姓名' align='center' />
          <el-table-column prop='driverTel' label='司机电话' min-width='120' align='center' />
          <el-table-column prop='fleetCount' label='运输数量' min-width='70' align='center' />
          <!-- <el-table-column prop="entruckDate" label="装车时间" min-width="140" align="center"/>
          <el-table-column prop="transportDate" label="运输时间" min-width="140" align="center"/>
          <el-table-column prop="deliveryDate" label="交车时间" min-width="140" align="center">
            <div slot-scope="scope">{{getTime(scope.row.deliveryDate)}}</div>
          </el-table-column> -->
          <el-table-column prop='startName' label='起始地' width='150px' show-overflow-tooltip
                           align='center'>
            <template slot-scope='scope'>
              <span
                :style="{'paddingRight':(scope.row.startType==1?'30px':'0px')}">{{ scope.row.startName
                }}</span>
              <i v-if='scope.row.startType==1' class='port-icon'
                 :title='scope.row.startPortName'>港</i>
            </template>
          </el-table-column>
          <el-table-column prop='deliveryName' label='交车地' width='150px' align='center'
                           show-overflow-tooltip>
            <template slot-scope='scope'>
              <span
                :style="{'paddingRight':(scope.row.deliveryType==1?'30px':'0px')}">{{ scope.row.deliveryName
                }}</span>
              <i v-if='scope.row.deliveryType==1' class='port-icon'
                 :title='scope.row.deliveryPortName'>港</i>
            </template>
          </el-table-column>
          <el-table-column prop='isBoard' label='是否换板' align='center'>
            <div slot-scope='scope'>{{ getIsBoard(scope.row.isBoard == 1) }}</div>
          </el-table-column>
          <el-table-column prop='status' label='状态' align='center'>
            <div slot-scope='scope'>{{ getState(scope.row.status) }}</div>
          </el-table-column>
          <el-table-column label='操作' min-width='240' align='center'>
            <template slot-scope='scope'>
              <div style='white-space: nowrap;display: inline-block;'>
                <el-button size='mini' class='searchBtn' type='primary'
                           @click='detailClick(scope.row.id)'>详情
                </el-button>
                <el-button v-if='scope.row.status==0||scope.row.status==5' size='mini' type='info'
                           @click='batchLoading(scope.row)'>批量装车
                </el-button>
                <el-button v-if='scope.row.status==5' size='mini' type='primary'
                           @click='loadingClick(scope.row.id)'>完成装车
                </el-button>
                <el-button v-if='scope.row.status==1' size='mini' type='primary'
                           @click='transportClick(scope.row.id)'>完成运输
                </el-button>
                <el-button size="mini" v-if='(scope.row.status===1 && scope.row.look===1) || (scope.row.status===2 && scope.row.look===1)'  type="primary" @click="driverTaskPopupClick(scope.row)">添加装车任务</el-button>
                <el-button v-if='scope.row.status==1' size='mini' type='primary'
                           @click='sectionDeliveryClick(scope.row.id)'>
                  分段交车
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
    <el-dialog title='详情' :visible.sync='detailDialogVisible' width='750px' center top='10vh'>
      <div class='detail'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem'>
              <span class='span1'>供应商名称：</span>
              <span>{{ detailData.supplierName }}</span>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>车牌号：</span>
              <span>{{ detailData.truckName }}</span>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>司机姓名：</span>
                <span>{{ detailData.driverName }}</span>
              </div>
              <div>
                <span class='span1'>司机电话：</span>
                <span>{{ detailData.driverTel }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>运输数量：</span>
              <span>{{ detailData.fleetCount }}</span>
            </div>
            <div class='baseInfoContentItem specialItem'>
              <div class='specialOne'>
                <span class='span1'>装车时间：</span>
                <span>{{ detailData.entruckDate }}</span>
              </div>
              <div>
                <span class='span1'>运输时间：</span>
                <span>{{ detailData.transportDate }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem'>
              <span class='span1'>交车时间：</span>
              <span>{{ detailData.deliveryDate }}</span>
            </div>
            <div class='baseInfoContentItem' style='margin-bottom: 0;'>
              <span class='span1'>起始地：</span>
              <span>{{ detailData.startName }}</span>
              <span v-if='detailData.startType==1'>【{{ detailData.startPortName }}】</span>
              <div class='addressItem'>{{ detailData.startDetail }}</div>
            </div>
            <div class='baseInfoContentItem' style='margin-bottom: 0;'>
              <span class='span1'>交车地：</span>
              <span>{{ detailData.deliveryName }}</span>
              <span v-if='detailData.deliveryType==1'>【{{ detailData.deliveryPortName }}】</span>
              <div class='addressItem'>{{ detailData.deliveryDetail }}</div>
            </div>
          </div>
        </div>
        <div class='operation'>
          <div class='operationTitle'>
            <div class='line' />
            <span>委托车</span>
          </div>
          <div class='operationTable'>
            <div v-model='queryForm' class='nav'>
              <div class='navContainer w160'>
                <p class='font-size-8'>批次号：</p>
                <el-input v-model='queryForm.batchNumber' size='mini' class='w135'
                          placeholder='输入批次号' />
              </div>
              <div class='navContainer w160'>
                <p class='font-size-8'>运单号：</p>
                <el-input v-model='queryForm.waybillNo' size='mini' class='w135'
                          placeholder='输入运单号' />
              </div>
              <div class='navContainer w160'>
                <p class='font-size-8'>车架号：</p>
                <el-input v-model='queryForm.frameNumber' size='mini' class='w135'
                          placeholder='输入车架号'
                          @paste.native.capture.prevent='(value)=>{ return searchCopyFormat(value,"frameNumber")}' />
              </div>
              <div class='navContainer w160'>
                <p class='font-size-8'>品牌：</p>
                <el-input v-model='queryForm.brand' size='mini' class='w135'
                          placeholder='输入品牌' />
              </div>
              <div class='navContainer w160'>
                <p class='font-size-8'>状态：</p>
                <el-select v-model='queryForm.state' class='w125' size='mini' filterable
                           clearable
                           placeholder='请选择'>
                  <el-option v-for='item in optionsState' :key='item.value' :label='item.label'
                             :value='item.value'></el-option>
                </el-select>
              </div>
              <div class='navBtn'>
                <el-button size='small' class='searchBtn' @click='carPageList'>查询</el-button>
                <el-button size='small' class='resetBtn' @click='resetCar'>重置</el-button>
                <el-button size='small' style='float: right;margin-right: 260px;' type='warning'
                           :disabled='selectionCar.length ==0 && selectionCar.length<=0'
                           @click='open'>回退
                </el-button>
                <span
                  style='float: right;margin-right: -177px;margin-top: 12px;'>回退数据：{{ selectionCar.length
                  }}条</span>
              </div>
            </div>
            <el-table :data='carData' border style='width: 100%'
                      ref='entrustCar'
                      key='entrustCar'
                      row-key='id'
                      v-loading='htLoading'
                      @selection-change='handleSelectionChangeCar'>
              <el-table-column type='selection' reserve-selection width='30' align='center' />
              <el-table-column prop='batchNumber' label='批次号' width='110' align='center' />
              <el-table-column prop='waybillNo' label='运单编号' width='110' align='center' />
              <el-table-column prop='frameNumber' label='车架号' width='110' align='center' />
              <el-table-column prop='brand' label='品牌' align='center' />
              <el-table-column label='起始地' align='center' :formatter='originFormat' />
              <el-table-column label='交车地' align='center' :formatter='deliveryPlaceFormat' />
              <el-table-column prop='model' label='型号' align='center' />
              <el-table-column prop='color' label='颜色' align='center' />
              <el-table-column prop='fileName' label='附件' align='center' />
              <el-table-column prop='state' label='状态' align='center' :formatter='getCarState2' />
            </el-table>
            <div class='paginationContainer mt10'>
              <span>共{{ carTotal }}条</span>
              <el-pagination
                background
                small
                :page-sizes='[10, 20, 30, 40]'
                layout='sizes,prev, pager, next,jumper'
                :total='carTotal'
                :current-page.sync='queryForm.page'
                @size-change='detailSizeChange'
                @current-change='detailChange'
                @prev-click='detailChange'
                @next-click='detailChange'
              />
            </div>
          </div>
        </div>
        <div class='operation'>
          <div class='operationTitle'>
            <div class='line' />
            <span>操作记录</span>
          </div>
          <div class='operationTable'>
            <el-table :data='detailData.operateRecordList' border style='width: 100%'>
              <el-table-column prop='createTime' label='操作时间' align='center'>
                <div slot-scope='scope'>{{ getTime(scope.row.createTime) }}</div>
              </el-table-column>
              <el-table-column prop='operateType' label='操作类型' align='center' />
              <el-table-column prop='operationName' label='操作人' align='center' />
              <el-table-column prop='remark' label='备注' align='center' />
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title='loadingTitle' :visible.sync='loadingVisible' width='500px'>
      <div style='padding:30px 50px'>
        <span class='required' style='display:inline-block;width:85px'>完成日期：</span>
        <el-date-picker
          size='mini'
          style='width:calc(100% - 85px)'
          v-model='loadingData.time'
          type='datetime'
          value-format='yyyy-MM-dd HH:mm:ss'
          placeholder='选择日期时间' />
      </div>
      <span slot='footer' class='dialog-footer'>
        <el-button size='mini' @click='loadingVisible = false'>取 消</el-button>
        <el-button size='mini' :loading='btnLoad' type='primary'
                   @click='loadingFinish'>确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title='批量装车' class='batch-dialog' :visible.sync='batchVisible' width='700px'>
      <div style='padding:30px 20px 10px'>
        <div-border label='基础信息'>
          <span class='required'
                style='display:inline-block;width:85px;margin-bottom:20px;'>装车日期：</span>
          <el-date-picker
            size='mini'
            style='width:calc(100% - 85px);margin-bottom:20px;'
            v-model='batchDate'
            type='datetime'
            value-format='yyyy-MM-dd HH:mm:ss'
            placeholder='选择日期时间' />
        </div-border>
        <div-border label='选择委托车'>
          <div class='nav' style='margin:0 0 10px'>
            <div class='navContainer' style='width: 200px'>
              <p style='width:60px;display:inline-block;text-align:right'>批次号：</p>
              <el-input v-model='entrustedTable.batchNumber' size='mini' style='width:130px'
                        placeholder='请输入批次号' />
            </div>
            <div class='navContainer' style='width: 200px'>
              <p style='width:60px;display:inline-block;text-align:right'>运单号：</p>
              <el-input v-model='entrustedTable.waybillNo' size='mini' style='width:130px'
                        placeholder='请输入运单号' />
            </div>
            <div class='navContainer' style='width: 200px'>
              <p style='width:60px;display:inline-block;text-align:right'>车架号：</p>
              <el-input v-model='entrustedTable.frameNumber' size='mini' style='width:130px'
                        placeholder='请输入车架号'
                        @paste.native.capture.prevent="(value)=>{ return searchCopyFormat(value,'entrustedTable.frameNumber')}" />
            </div>
            <div class='navBtn'>
              <el-button size='mini' class='searchBtn' @click='carSearchBtn'>查询</el-button>
              <el-button size='mini' class='resetBtn' @click='carResetBtn'>重置</el-button>
            </div>
          </div>
          <el-table
            :data='tableList'
            v-loading='carTableLoad'
            style='width: 100%' border stripe
            @expand-change='expandChange'
            :header-cell-style="{color:'#3B3B3B','padding':'0px','font-size':'13px','height':'30px',background:'#E8E8E8'}"
            :cell-style="{'color':'#7F7F7F','padding':'0px','font-size':'13px','height':'30px'}">
            <el-table-column type='expand' width='30'>
              <template slot-scope='scopeOut'>
                <div style='width: 95%;margin-left: auto;' v-loading='scopeOut.row.loading'>
                  <el-table
                    :data='scopeOut.row.children'
                    border
                    max-height='300'
                    style='width: 100%'
                    :ref='scopeOut.row.batch_number+scopeOut.row.waybill_no'
                    @selection-change='handleCurrentChange($event,scopeOut.$index)'
                    :header-cell-style="{color:'#3B3B3B','padding':'0px','font-size':'13px','height':'30px',background:'#E8E8E8'}"
                    :cell-style="{'color':'#7F7F7F','padding':'0px','font-size':'13px','height':'30px',}">
                    <el-table-column type='selection' align='center' width='50px' />
                    <el-table-column prop='frame_number' label='车架号' min-width='130' align='center'>
                      <template slot-scope='scope'>
                        <span v-if='scope.row.state==1'
                              class='require'>{{ scope.row.frame_number }}</span>
                        <span v-else>{{ scope.row.frame_number }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop='brand_name' label='品牌' min-width='100' align='center' />
                    <el-table-column prop='model_name' label='型号' min-width='100' align='center' />
                    <el-table-column prop='weight' label='重量' align='center' />
                    <el-table-column prop='departure_port' label='交车港口' align='center' />
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop='batch_number' label='批次号' align='center'>
              <template slot-scope='scope'>
                <span v-if='scope.row.state==1' class='require'>{{ scope.row.batch_number }}</span>
                <span v-else>{{ scope.row.batch_number }}</span>
              </template>
            </el-table-column>
            <el-table-column prop='waybill_no' label='运单号' align='center' />
            <el-table-column prop='count_car' label='数量' align='center' />
          </el-table>
          <div class='paginationContainer' style='margin: 10px 0px;'>
            <span>共{{ entrustedTable.total }}条</span>
            <el-pagination
              background
              :page-size='10'
              layout='prev, pager, next,jumper'
              :total='entrustedTable.total'
              @size-change='conditionSizeChange'
              @current-change='conditionCurrentChange'
              @prev-click='conditionCurrentChange'
              @next-click='conditionCurrentChange' />
          </div>
        </div-border>
      </div>
      <span slot='footer' class='dialog-footer'>
        <el-button size='mini' @click='batchVisible = false'>取 消</el-button>
        <el-button size='mini' :loading='btnLoad' type='primary'
                   @click='batchFinish'>确 定</el-button>
      </span>
    </el-dialog>

    <!-- 分段交车 -->
    <section-delivery ref='sectionDeliveryRef' />
    <driverTaskPopup ref="driverTaskPopup" @_driverLoadingPageList="_driverLoadingPageList"/>
  </div>
</template>

<script>
  import divBorder from '@/components/divBorder';
  import {
    driverTransportFinish,
    driverLoadingFinish,
    driverLoadingDetail,
    driverLoadingPageList,
    loadingPageList,
    loadingChildPageList,
    batchFinish,
    vehicleDetailPageList,
    vehicleErrorFallback,
  } from '@/service/vehiclelog';
  import { formatDateTime } from '@/config/mUtils';
  import SectionDelivery
    from '@/views/vehiclelog/planManage/components/driver-components/sectionDelivery';
  import driverTaskPopup from '@/views/vehiclelog/planManage/components/driver-task-popup/driverTaskPopup';
  export default {
    components: {
      SectionDelivery,
      divBorder,
      driverTaskPopup,
    },
    data() {
      return {
        deployPortId: '',
        selectionCar: [],
        htLoading: false,
        // 查询条件
        condition: {
          supplierName: '',
          truckName: '',
          driverName: '',
          isBoard: '',
          status: '',
        },
        // 换板状态
        isBoardOption: [
          {
            name: '全部',
            val: '',
          },
          {
            name: '未换板',
            val: '0',
          },
          {
            name: '已换板',
            val: '1',
          },
        ],
        // 状态
        statusOption: [
          {
            name: '全部',
            val: '',
          },
          {
            name: '待开始',
            val: '0',
          },
          {
            name: '运输中',
            val: '1',
          },
          {
            name: '已交车',
            val: '2',
          },
          {
            name: '装车中',
            val: '5',
          },
        ],
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,   // 表格加载状态
        TableDatas: [],  // 表格数据
        btnLoad: false,
        // 详情
        detailDialogVisible: false,
        detailData: {},
        // 批量装车、完成装车时间
        dateList: {
          beach: '',
          load: '',
        },
        // 完成装车/运输
        loadingVisible: false,
        loadingTitle: '',
        loadingData: {
          id: '',
          time: '',
        },
        // 批量装车
        entrustedTable: {   // 批量装车 查询条件
          position: '',
          startPort: '',
          entrust: '',
          batchNumber: '',
          waybillNo: '',
          frameNumber: '',
          page: 1,
          size: 10,
          total: 0,
        },
        batchVisible: false,
        tableList: [],
        carTableLoad: false,
        selectData: [],
        batchDate: '',
        batchId: '',
        defaultForm: {},
        queryForm: {
          deployPortId: '',
          rows: 10,
          page: 1,
          batchNumber: '',
          waybillNo: '',
          frameNumber: '',
          brand: '',
          startPortName: '',
          deliveryPortName: '',
          state: '',
        },
        carData: [], // 委托车信息
        carTotal: 0, // 委托车数据量
        optionsState: [{
          value: '0',
          label: '待装车',
        }, {
          value: '1',
          label: '已装船',
        }, {
          value: '2',
          label: '已交车',
        }, {
          value: '-1',
          label: '已取消',
        }],
      };
    },
    computed: {
      getTime() {
        return function(time) {
          if (time) {
            return formatDateTime(time, 'yyyy-mm-dd hh:ii:ss');
          } else {
            return '';
          }
        };
      },
      getCarState() {
        return function(value) {
          if (value > 0) {
            return '已分配';
          } else {
            return '未分配';
          }
        };
      },
      getIsBoard() {
        return function(state) {
          if (state == 1) {
            return '是';
          } else {
            return '否';
          }
        };
      },
      getState() {
        return function(state) {
          switch (state) {
            case 0:
              return '待开始';
            case 1:
              return '运输中';
            case 2:
              return '已交车';
            case 5:
              return '装车中';
          }
        };
      },
    },
    mounted() {
      this.init();
      this.defaultForm = JSON.parse(JSON.stringify(this.queryForm));
    },
    methods: {
      getCarState2(r, c, cellValue) {
        switch (cellValue) {
          case -1:
            return '取消';
          case 0:
            return '待运输';
          case 1:
            return '运输中';
          case 2:
            return '已交车';
        }
      },
      // 格式化起始地
      originFormat(row) {
        return row.startPortName ? row.startPortName : row.startName;
      },
      // 格式化起始地
      deliveryPlaceFormat(row) {
        return row.deliveryPortName ? row.deliveryPortName : row.deliveryName;
      },
      // 重置
      resetCar() {
        this.queryForm = JSON.parse(JSON.stringify(this.defaultForm));
        this.queryForm.deployPortId = this.deployPortId;
      },
      // 弹出框分页查询
      async carPageList() {
        const {
          message,
          status,
          data: {
            records,
            total,
          },
        } = await vehicleDetailPageList(this.queryForm);
        if (status !== 0) return this.$message.error(message);
        this.carTotal = total;
        this.carData = records;
      },
      async init() {
       // await this._driverLoadingPageList();
      },
      open() {
        this.$confirm('是否回退' + this.selectionCar.length + '条数据！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            //调用回退接口
            this.htLoading = true;
            let obj = {
              type: 0,
              deployPortId: this.deployPortId,
              carIdList: this.selectionCar,
            };
            const res = await vehicleErrorFallback(obj);
            if (res.status !== 0) {
              this.$message.error(res.message);
              this.htLoading = false;
            }
            if (res.status == 0) {
              this.$message.success(res.message);
              if (this.$refs.entrustCar) this.$refs.entrustCar.clearSelection();
              this.selectionCar = [];
              const res2 = await driverLoadingDetail(this.deployPortId);
              this.detailData = res2.data;
              this.htLoading = false;
              await this.carPageList();
            }
          })
          .catch(() => {
            if (this.$refs.entrustCar) this.$refs.entrustCar.clearSelection();
            this.selectionCar = [];
          });
      },
      handleSelectionChangeCar(val) {
        this.selectionCar = val;
      },
      // 分页查询
      async _driverLoadingPageList() {
        const obj = {
          ...this.condition,
          rows: this.size,
          page: this.page,
        };
        this.tableLoad = true;
        const res = await driverLoadingPageList(obj);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      // 每页数据条数改变
      contractSizeChange(sizes) {
        this.size = sizes;
        this._driverLoadingPageList();
      },
      // 当前页改变
      contractCurrentChange(page) {
        this.page = page;
        this._driverLoadingPageList();
      },
      // 详情
      async detailClick(id) {
        this.selectionCar = [];
        if (this.$refs.entrustCar) this.$refs.entrustCar.clearSelection();
        const res = await driverLoadingDetail(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.detailData = res.data;
        this.detailDialogVisible = true;
        this.deployPortId = id;
        this.queryForm.deployPortId = id;
        this.queryForm.page = 1;
        await this.carPageList();
      },

      // 批量装车 —— 打开弹窗
      batchLoading(row) {
        this.carResetBtn();
        this.batchId = row.id;
        this.selectData = [];
        this.tableList = [];
        this.batchDate = '';
        this.entrustedTable.position = row.startId;
        this.entrustedTable.startPort = row.startPortId || '';
        this.entrustedTable.entrust = row.supplierId;
        this.entrustedTable.deployId = row.basicId;
        this.batchVisible = true;
        this.carSearchBtn();
        this.dateList.beach = row.entruckDate;
        this.dateList.load = row.transportDate;
      },
      // 批量装车 —— 确认
      async batchFinish() {
        if (!this.batchDate || this.batchDate == '') return this.$message.warning('请选择装车日期！');
        let list = [];
        this.selectData.forEach(item => {
          list = list.concat(item.list);
        });
        if (list.length === 0) return this.$message.warning('请至少选择一个委托车！');
        let obj = {
          id: this.batchId,
          entruckDate: this.batchDate,
          vehicleCarList: list.map(item => {
            return { id: item.id };
          }),
        };
        this.btnLoad = true;
        const res = await batchFinish(obj);
        this.btnLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.batchVisible = false;
        await this._driverLoadingPageList();
      },
      // 批量装车 —— 查询
      async carSearchBtn() {
        // this.entrustedTable
        let obj = {
          type: 0,
          departurePlaceId: this.entrustedTable.position,
          departurePortId: this.entrustedTable.startPort || '',
          supplierId: this.entrustedTable.entrust,
          deployId: this.entrustedTable.deployId,
          batchNumber: this.entrustedTable.batchNumber,
          waybillNo: this.entrustedTable.waybillNo,
          frameNumber: this.entrustedTable.frameNumber,
          page: this.entrustedTable.page,
          rows: this.entrustedTable.size,
        };
        this.carTableLoad = true;
        const res = await loadingPageList(obj);
        this.carTableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        // 给数据加上 index和children
        if (res.data.records.length > 0) {
          res.data.records.forEach((item, index) => {
            item.index = index;
            item.loading = true;
            item.children = [];
          });
        }
        this.tableList = res.data.records;
        this.entrustedTable.total = res.data.total;
      },
      // 新增 装车车辆 二级 —— 查询
      async carSearchChildBtn(row) {
        let obj = {
          type: 0,
          departurePlaceId: this.entrustedTable.position,
          departurePortId: this.entrustedTable.startPort || '',
          supplierId: this.entrustedTable.entrust,
          deployId: this.entrustedTable.deployId,
          batchNumber: row.batch_number,
          waybillNo: row.waybill_no,
        };
        const res = await loadingChildPageList(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.tableList[row.index].children = res.data;
      },
      // 展开行时是否查询 装车车辆 二级
      async judgeFn(row) {
        if (this.tableList[row.index].children.length <= 0) {
          let obj = {
            type: 0,
            departurePlaceId: this.entrustedTable.position,
            departurePortId: this.entrustedTable.startPort,
            supplierId: this.entrustedTable.entrust,
            deployId: this.entrustedTable.deployId,
            batchNumber: row.batch_number,
            waybillNo: row.waybill_no,
            frameNumber: this.entrustedTable.frameNumber,
          };
          const res = await loadingChildPageList(obj);
          if (res.status !== 0) return this.$message.error(res.message);
          this.tableList[row.index].children = res.data;
        }
        return Promise.resolve;
      },
      // 批量装车 —— 展开行
      expandChange(row, val) {
        const isExpend = val.some(r => r.index === row.index);
        if (isExpend && val.length > 0) {
          this.tableList[row.index].loading = true;
          // 新增 装车车辆 二级 —— 查询
          // if(tableList[row.index].children.length <= 0){
          //   this.carSearchChildBtn(row);
          // }
          Promise.all([this.judgeFn(row)])
            .then(() => {
              if (this.selectData.length > 0) {
                let flg = false;
                this.selectData.forEach(item => {
                  if (item.id == row.batch_number + row.waybill_no) {
                    if (item.list.length > 0) {
                      item.list.forEach(tem => {
                        this.$nextTick(() => {
                          this.$refs[row.batch_number + row.waybill_no].toggleRowSelection(
                            this.tableList[row.index].children.find(tem1 => {
                              return tem.id == tem1.id;
                            })
                            , true);
                        });
                      });
                    }
                    return flg = true;
                  }
                });
                if (!flg) {
                  this.selectData.push({
                    id: row.batch_number + row.waybill_no,
                    list: [],
                  });
                }
              } else {
                this.selectData.push({
                  id: row.batch_number + row.waybill_no,
                  list: [],
                });
              }
              this.tableList[row.index].loading = false;
            });
        }
      },
      // 批量装车 —— 多选框选择
      handleCurrentChange(val, index) {
        if (val.length > 0) {
          this.selectData.filter(item => {
            if (item.id == val[0].batch_number + val[0].waybill_no) {
              item.list = val;
            }
          });
        }
      },
      // 批量装车 —— 切换每页数据条数
      conditionSizeChange(sizes) {
        this.entrustedTable.size = sizes;
        this.carSearchBtn();
      },
      // 批量装车 —— 换页
      conditionCurrentChange(page) {
        this.entrustedTable.page = page;
        this.carSearchBtn();
      },
      // 批量装车 —— 重置
      carResetBtn() {
        this.entrustedTable.batchNumber = '';
        this.entrustedTable.waybillNo = '';
        this.entrustedTable.frameNumber = '';
      },


      // 完成装车 —— 打开弹窗
      loadingClick(id) {
        this.loadingTitle = '完成装车';
        this.loadingVisible = true;
        this.loadingData.id = id;
        this.loadingData.time = '';
        this.dateList.beach = row.entruckDate;
        this.dateList.load = row.transportDate;
      },
      // 完成装车/运输 —— 确认
      async loadingFinish() {
        if (!this.loadingData || this.loadingData.time == '') return this.$message.error('请选择完成日期！');
        let obj = {};
        let res;
        if (this.loadingTitle == '完成装车') {
          if (this.dateList.beach && this.dateList.beach != '' && this.loadingData.time < this.dateList.beach) {
            return this.$message.error('完成装车日期不得小于装车日期！');
          }
          this.btnLoad = true;
          obj = {
            id: this.loadingData.id,
            transportDate: this.loadingData.time,
          };
          res = await driverLoadingFinish(obj);
        } else {
          if (this.dateList.load && this.dateList.load != '' && this.loadingData.time < this.dateList.load) {
            return this.$message.error('完成运输日期不得小于完成装车日期！');
          }
          this.btnLoad = true;
          obj = {
            id: this.loadingData.id,
            deliveryDate: this.loadingData.time,
          };
          res = await driverTransportFinish(obj);
        }
        this.btnLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.loadingVisible = false;
        await this._driverLoadingPageList();
      },
      // 完成运输
      transportClick(id) {
        this.loadingTitle = '完成运输';
        this.loadingVisible = true;
        this.loadingData.id = id;
      },
      // 查询
      searchBtn() {
        this.page = 1;
        this._driverLoadingPageList();
      },
      // 重置
      resetBtn() {
        for (let key in this.condition) {
          this.condition[key] = '';
        }
      },
      // 时间长度处理(只显示年月日)
      getDate(row, column, cellValue) {
        if (cellValue) {
          return cellValue.substring(0, 10);
        } else {
          return '';
        }
      },
      // 将null转换为0
      convert0(row, column, cellValue) {
        if (cellValue) {
          return cellValue;
        } else {
          return '0';
        }
      },
      searchCopyFormat(value, flag) {
        let splitArr = value.clipboardData.getData('Text')
          .replace(/\s/g, ',')
          .split(',');
        splitArr = splitArr.filter(item => item);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        switch (flag) {
          case 'entrustedTable.frameNumber':
            this.entrustedTable.frameNumber = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
          case 'frameNumber':
            this.queryForm.frameNumber = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
        }
      },
      // 详情 —— 分页大小改变
      detailSizeChange(size) {
        // 每页条数
        this.queryForm.rows = size;
        this.carPageList();
      },
      // 详情 —— 当前页改变
      detailChange(page) {
        // 翻页
        this.queryForm.page = page;
        this.carPageList();
      },
      sectionDeliveryClick(id) {
        this.$refs.sectionDeliveryRef.dialogOpen(id);
      },
      driverTaskPopupClick(row){
        this.$refs.driverTaskPopup.taskPage(row);
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 15px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    ::v-deep.detail2 {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      .tableAddBtnContainer {
        border: 1px solid #EBEEF5;;
        border-top-style: none;
        width: 100%;
        //height: 35px;
        display: flex;
        align-items: center;
        //padding-left: 15px;
        ::v-deep {
          .el-select .el-input.is-focus .el-input__inner {
            border-color: #DCDFE6;
          }

          .el-select .el-input__inner:focus {
            border-color: #DCDFE6;
          }
        }

        .AddContainer {
          display: flex;
          align-items: center;

          &:hover {
            cursor: pointer;
          }
        }

        img {
          object-fit: cover;
          margin-right: 5px;
        }

        p {
          font-size: 13px;
          color: #F59A23;
          font-family: 'Arial Normal', 'Arial', sans-serif;
        }

        .addBtn {
          outline: none;
          width: 100%;
          color: #3d3d3d;
          background-color: #fff;
          border: 1px solid #CECECE;
          font-size: 12px;
          height: 20px;

          &:hover {
            cursor: pointer;
          }
        }
      }

      .el-table td {
        padding: 5px 0;
      }

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          .addressItem {
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
            margin-bottom: 10px;
            margin-left: 70px;
          }

          .el-form-item__label {
            font-weight: 700;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        .el-form-item {
          margin-bottom: 0 !important;
        }

        ::v-deep {
          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;


        }
      }

      ::v-deep {
        .el-input--mini .el-input__inner {
          width: 100%;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }

        .el-table td, .el-table th {
          padding: 0;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          .addressItem {
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
            margin-bottom: 10px;
            margin-left: 70px;
          }

          &Item {
            margin-bottom: 15px;

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td, .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    .company {
      width: 100%;
      padding: 20px 30px 20px 30px;
      max-height: 75vh;
      overflow: auto;

      .team {
        margin: 20px 0 10px 0;

        &Add {
          display: flex;
          align-items: center;
          margin-left: 10px;
          margin-top: 10px;

          .add {
            width: 20px;
            height: 20px;
            padding-bottom: 3px;
            background-color: #999;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 30px;
            margin-right: 15px;

            &:hover {
              cursor: pointer;
            }
          }

          span {
            font-size: 14px;
            color: #606266;
            font-weight: 700;
          }
        }

        &Item {
          display: flex;
          align-items: center;
          color: #999;
          font-size: 14px;
          margin-top: 10px;
          padding-bottom: 10px;

          span {
            margin-left: 5px;
            color: #606266;
            font-weight: 700;
          }

          border-bottom: 1px solid #CBCBCB;
        }
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item {
          margin-bottom: 12px;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      .transport {
        width: 100%;
        border: 1px solid #C3C3C3;
        position: relative;
        padding: 0 10px;
        margin-bottom: 20px;

        .productTable {
          margin-top: 15px;

          ::v-deep {
            .el-input--mini .el-input__inner {
              width: 100%;
            }

            .cell {
              font-size: 10px;
              padding: 0;
            }

            .el-table td, .el-table th {
              padding: 0;
            }
          }

          .tableAddBtnContainer {
            border: 1px solid #EBEEF5;;
            border-top-style: none;
            width: 100%;
            //height: 35px;
            display: flex;
            align-items: center;
            //padding-left: 15px;
            ::v-deep {
              .el-select .el-input.is-focus .el-input__inner {
                border-color: #DCDFE6;
              }

              .el-select .el-input__inner:focus {
                border-color: #DCDFE6;
              }
            }

            .AddContainer {
              display: flex;
              align-items: center;

              &:hover {
                cursor: pointer;
              }
            }

            img {
              object-fit: cover;
              margin-right: 5px;
            }

            p {
              font-size: 13px;
              color: #F59A23;
              font-family: 'Arial Normal', 'Arial', sans-serif;
            }

            .addBtn {
              outline: none;
              width: 100%;
              color: #3d3d3d;
              background-color: #fff;
              border: 1px solid #CECECE;
              font-size: 12px;
              height: 20px;

              &:hover {
                cursor: pointer;
              }
            }
          }

          .paginationContainer {
            margin-right: auto;
            display: flex;
            align-items: center;
            margin-bottom: 20px;

            span {
              font-size: 13px;
            }
          }
        }

        &Title {
          margin-bottom: 0;
          position: absolute;
          top: -21px;
          z-index: 999;
          background-color: #fff;
          left: 20px;
          padding-right: 10px;
          color: rgb(51, 84, 131);
          font-size: 15px;
          font-weight: 700;

          ::v-deep {
            .el-form-item__label {
              color: rgb(51, 84, 131);
              font-size: 15px;
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px 0 5px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }

    ::v-deep .batch-dialog {
      .el-dialog__body {
        max-height: 65vh;
        overflow-y: auto;
      }
    }
  }

  ::v-deep {
    .el-table .cell.el-tooltip span:first-child {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
      max-width: 150px;
    }

    .el-table__expanded-cell {
      padding: 0px;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }

    .transport {
      padding-top: 20px !important;
    }

    .el-button + .el-button {
      margin-left: 5px !important;
    }
  }

  i.port-icon {
    position: absolute;
    display: inline-block;
    left: 120px;
    width: 20px;
    height: 20px;
    cursor: pointer;
    text-align: center;
    line-height: 20px;
    background: red;
    color: #fff;
    border-radius: 50%;
  }

  .del-style {
    text-align: left;
    padding-left: 20px;
    height: 28px;
    line-height: 28px;

    ::v-deep {
      .el-radio {
        margin-right: 15px;

        .el-radio__label {
          display: none;
        }
      }

      i.el-icon-error {
        height: 28px;
        line-height: 28px;
        font-size: 16px;
      }
    }
  }

  .required:before {
    content: '* ';
    color: red;
  }

  .paginationContainer {
    margin-right: auto;
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    span {
      font-size: 13px;
    }
  }

  .navContainer p {
    display: inline-block;
    width: 85px;
    text-align: right;
  }
</style>
